// extracted by mini-css-extract-plugin
module.exports = {"canvas":"staticCanvas_canvas__YAp_u"};